import { Component, OnInit, ViewChild, Injector, model, ChangeDetectionStrategy } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { encryptData, decryptData } from '../../../core/utilities';
import { ResponseCodeVerifyCustomer, Customer } from '../models/customer.model';
import { LineStateActionService } from '../statemanagement/line-state-action.service';
import { SetCustomerAction } from '../statemanagement/action/customer.action';
import { BaseComponents } from '../../../base.component';
import { ReferenceService } from 'src/app/services/reference.service';
import { GetMaskingService } from 'src/app/adapters/getMasking.service';

@Component({
    selector: 'app-new-user',
    templateUrl: './new-user.component.html',
    styleUrls: ['./new-user.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NewUserComponent extends BaseComponents implements OnInit {

    model = model<any>({
        form: {
            firstName: { value: '', text: '' },
            lastName: { value: '', text: '' },
            idcard: { value: '', text: '' },
            mobile: { value: '', text: '' },
            chanelId: { value: '', text: '' },
            userId: { value: '', text: '' },
            chanelLiffNumber: { value: '', text: '' }
        }
    });
    update_channel_identity_flag: boolean = false;
    regName = /^[-.a-zA-Z\sกขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮะัาำิีึืฺุูเแโใไ็่้๊๋์]+$/;

    invalidInformation = false;
    comCode: string;
    ref: string = "";
    liff_motor: string = "";
    flow: number;
    log_session_text: string = "new-user";
    referenceUUID: string | null = null;
    constructor(
        protected injectorObj: Injector,
        private router: Router,
        private route: ActivatedRoute,
        private lineStateAction: LineStateActionService,
        private lineActionService: LineStateActionService,
        private referenceService:ReferenceService,
        private getMaskingService : GetMaskingService,
    ) {
        super(injectorObj);
     }

    ngOnInit() {
        const funcName = 'ngOnInit';
        this.referenceUUID = this.referenceService.getReferenceUUID();
        this.log_session_text = `new-user referenceUUID:[${this.referenceUUID}]`;
        this.logger.info(`${this.log_session_text} ${funcName} start`);
        this.route.queryParams.subscribe(params => {
            let receive = params['params'];
            receive = this.decryptData(receive);
            console.log(receive);
            const current = structuredClone(this.model());
            current.form.mobile.value = receive.mobile;
            current.form.idcard.value = receive.idcard;
            current.form.chanelId.value = receive.chanelId;
            current.form.userId.value = receive.userId;
            current.form.chanelLiffNumber.value = receive.chanelLiffNumber
            this.model.set(current);
            this.comCode = receive.comCode;
            this.update_channel_identity_flag = receive.update_channel_identity_flag;
            this.ref = receive.ref
            this.liff_motor = receive.liff_motor
            this.flow = receive.flow
          });
          
        this.lineActionService.observableCustomer.subscribe(
            result => {
                this.logger.info(`${this.log_session_text} ${funcName} result of observable success`)
            }
        )
    }

    decryptData(re_data) {
        if (re_data != "" && re_data != null) {
            let result = JSON.parse(
                decodeURIComponent(
                    Array.prototype.map.call(
                        atob(decryptData(re_data)), function (c) {
                            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
                        }).join('')
                )
            )
            return result;
        }
    }

    onSubmit() {
        this.redirectConfirmOTP();
    }

    addClass(f: NgForm, field: string, type?: string, valueActive = '') {
        const iClass = [];
        if (f.form.get(field) && type !== 'msg') {
            if (f.form.get(field).invalid && (f.form.get(field).dirty || f.form.get(field).touched || f.submitted)) {
                iClass.push('uk-form-danger');
            } else if (f.form.get(field).valid && (f.form.get(field).dirty || f.form.get(field).touched || f.submitted)) {
                if (valueActive === '') {
                    iClass.push('uk-form-success');
                } else if (f.form.get(field).value === valueActive) {
                    iClass.push('uk-form-success');
                }
            }
        } else if (f.form.get(field) && type === 'msg') {
            if (f.form.get(field).invalid && (f.form.get(field).dirty || f.form.get(field).touched || f.submitted)) {
                iClass.push('uk-animation-fade');
            } else if (f.form.get(field).valid && (f.form.get(field).dirty || f.form.get(field).touched || f.submitted)) {
                iClass.push('uk-animation-reverse');
            }
        }

        return iClass;
    }

    
    private redirectConfirmOTP() {
        const funcName = 'redirectConfirmOTP';
        try{            
            this.logger.info(`${this.log_session_text} ${funcName} start`);
            const params = {
                update_channel_identity_flag: this.update_channel_identity_flag,
                ref: this.ref, liff_motor: this.liff_motor , flow: this.flow
            }
            const customer: Customer = {
                "firstname": this.model().form.firstName.value,
                "lastname": this.model().form.lastName.value,
                "new_plateform_customer_flag": 1
            }
            const log_customer = {
                ...customer,
                "firstname": this.getMaskingService.maskingData(customer.firstname),
                "lastname": this.getMaskingService.maskingData(customer.lastname),
            }
            this.logger.info(`${this.log_session_text} ${funcName} customer:${JSON.stringify(log_customer)} and goto confirm-otp`);
            this.lineStateAction.sinkCustomer.next(new SetCustomerAction(customer));
            const query = encryptData(this.b64EncodeUnicode(JSON.stringify(params)));
            this.router.navigate(['../confirm-otp'], { relativeTo: this.route, queryParams: { params: query }});
        }catch(error) {
            this.logger.info(`${this.log_session_text} ${funcName} error:${error?.message}`);
        }        
    }

    b64EncodeUnicode(str) {
        return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (match, p1) {
            return String.fromCharCode(parseInt(p1, 16))
        }))
    }
}
